export default {
    listMailError: state => state.listMailError,
  }